import React from 'react'
import Skeleton from 'react-loading-skeleton';

function RecentArticleSkeleton() {
    return (
        <article className="post">
            {/* <figure className="post-thumb"><img src={image} alt='' /></figure> */}
            <Skeleton className="post-thumb" />
            <div className="text"><a href={`/posts/`}><Skeleton /></a>
            </div>
            <div className="post-info"><Skeleton /></div>
        </article>
    )
}

export default RecentArticleSkeleton
